module.exports = {"default_Required_Message":"Required","default_Email_Message":"Not a valid email","default_Numeric_Message":"Only numeric","default_EmailFormat_Message":"Invalid email"}


//////////////////
// WEBPACK FOOTER
// ./src/validation/customMessages/config.json
// module id = wPjF
// module chunks = 1